// ANCHOR React
import { ChangeEvent, KeyboardEvent } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import { useUpdateFormFormTimeLimit } from '@lyon/scoped-models/form/update/UpdateFormForm';

// ANCHOR Hooks
import { useConstantCallback } from '@lyon/utils/hooks/useConstantCallback';

// ANCHOR Utils
import { numberOnlyInput } from '@lyon/utils/extras/numberOnlyInput';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { FormField } from '@lyon/components/utils/FormField';

// ANCHOR Constants
import {
  PLACEHOLDER, TITLE, CAPTION, END_ENHANCER,
} from './constants';

export const LyonUpdateFormTimeLimit = constant(() => {
  const [timeLimit, setTimeLimit] = useUpdateFormFormTimeLimit();

  const onChange = useConstantCallback((event: ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.currentTarget.value);

    if (!Number.isNaN(value) && value > -1) {
      setTimeLimit(value);
    }
  });

  const onKeyPress = useConstantCallback((event: KeyboardEvent<HTMLInputElement>) => {
    numberOnlyInput(event);
  });

  return (
    <Block marginTop="32px">
      <FormField
        value={timeLimit ?? ''}
        onChange={onChange}
        label={TITLE}
        placeholder={PLACEHOLDER}
        onKeyPress={onKeyPress}
        endEnhancer={END_ENHANCER}
        required
        caption={CAPTION}
      />
    </Block>
  );
});
